<template>
    <my-form
    v-model="form"
    table
    label-width="180px"
    @submit="submitHandler">
        <el-form-item
        class="table-full-row"
        label="操作"
        >
        	<!-- <a href="{{mburl}}" target="_blank">我的门户网站（点击进入）</a> -->
         我的门户网站(点击进入)
        </el-form-item>

        <el-form-item
        class="table-full-row"
        label="域名"
        >           
         <!-- {{form.domain}} -->
         123
        </el-form-item>
         <el-form-item
        class="table-full-row"
        label="选择模板"
        >
        <ul class="template">
					<!-- <li ng-repeat="item in limapweb">
						<a ng-href="{{item.sltimgoption}}" target="_blank">
							<img ng-src="{{item.sltimgoption}}">
						</a>
						<p style="text-align: center;margin: 10px 0;cursor: pointer;">
							<input type="radio" name="temp" ng-model="form.mbguid" value="{{item.guid}}">{{item.mbname}}
						</p>
					</li> -->      
                    <!-- <li v-for="item in limapweb" key="item.guid">
                        <label for="item.guid">
                            <a href="{{item.sltimgoption}}" target="_blank">
                                <img :src="item.sltimgoption" class="moban">
                            </a>
                            <input type="radio" name="a" v-model="form.mbguid" class="a" value="item.guid" id="a">
                            <span>{{item.mbname}}</span>
                        </label>         
                    </li> -->     
                    <li class="aa">
                         <label for="a">
                             <div class="big">
                                  <img src="./img/look.jpg" class="moban">
                                  <img src="./img/duigou.jpg" class="duigou">

                             </div>
                       
                            <input type="radio" name="a" class="a" value="a" id="a">
                            <span>第一套模板</span>
                        </label>
                    </li>
                    <li class="aa">
                         <label for="b">
                        <img src="./img/looker.jpg" class="moban">
                            <input type="radio" name="a" class="a" value="b" id="b">
                            <span>第二套模板</span>
                              
                            
                        </label>
                    </li>
                    <li class="aa">
                         <label for="c">
                        <img src="./img/looksan.jpg" class="moban">
                            <input type="radio" name="a" class="a" value="c" id="c">
                            <span>第三套模板</span>
    
                            
                        </label>
                    </li>
                    <li class="aa">
                         <label for="d">
                        <img src="./img/looksi.jpg" class="moban">
                            <input type="radio" name="a" class="a" value="d" id="d">
                            <span>第四套模板</span> 
                        </label>
                    </li>
    
				</ul>
        </el-form-item>
         <el-form-item
        class="table-full-row"
        label="关于我们"
        >
         <textarea>
             关于我们（第一套模板，元素：绿色、建筑、叠层、横向四个模块）VR的测试
          </textarea>
        </el-form-item>
        <template slot="btn" slot-scope="scope">
            <el-button
            @click="scope.submitHandler"
            type="primary"
            icon="el-icon-circle-check">
                保存
            </el-button>
        </template>
    </my-form>
</template>    
                         
<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

// import ThState from '../../components/th-state'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    // components: { ThState },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        form: {
            adduserid: "1",
            addusername: "admin",
            domain: "aaa123",
            dwcode: "E0000007302",
            dwname: "惠招标签章测试六",
            guid: "07967447fb91406086d9398db492753f",
            gywm: "关于我们（第一套模板，元素：绿色、建筑、叠层、横向四个模块）VR的测试",
            isqy: "1",
            mbguid: "b93786342e464fef9213bc6ea63633f6"
        },
        mburl:''
       
    }),
    computed: {
    
    },
    methods: {
         submitHandler() {
             $.get('/updatewebdw.json',this.form,function(res,data){
                 console.log(res.result)
					// if(res.result){
					// 	jsmsg('保存成功', "提示", null, null,"/myweb.do", "Success");
		
					// }else{
					// 	jsmsg(res.msg,"提示", null, null,null, "error")
					// }
	
				})
        }  
    },
    created() {
    
     }
}
</script>

<style scoped lang="scss">
.moban {
    width: 150px;
    height: 150px;
}
ul li {
    float: left;
    margin-right: 15px;
}
.a {
    display: none;
}
.aa {
    position:relative;
}
.a[type=radio]+span {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
   align-items: center;
  margin-bottom: 0.375em;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
  cursor: pointer;
}
.a[type=radio]+span:hover {
  background-color: #edd8e0;
}
.a[type=radio]+span:before {
  display: -webkit-box;
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #900c3f;
}
.a[type=radio]:checked + span { 
  background-color: #edd8e0;
  color: #900c3f;
}
.a[type=radio]:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #900c3f;
}
.a[type=radio]:checked img { 
 width: 10px;
}                           
.xuanxiang {
    margin-left: 25px;
}
.moban {
     opacity: 0.5;
     position: relative;
     border: 2px solid #900c3f;

}                                            
.big {
    position: relative;
}
 .duigou {
     position: absolute;
     width: 18px;
     height: 18px;
     border-radius: 7px;
     top: 63px;
     right: 63px;
     cursor: pointer;
     text-align: center;
     line-height: 14px;
     display: inline-block;
 }


</style>
